import React from 'react';
import PropTypes from 'prop-types';

import { InputAdornment, TextField } from '@mui/material';
import { capitalize, omit } from 'lodash';

import { FORM_PROVIDER_PROPS } from '@shared/ui/formProviderProps';

const propTypes = {
  handleChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,

  values: PropTypes.object.isRequired,
  errors: PropTypes.object,

  label: PropTypes.string,
  type: PropTypes.string,
};

const defaultProps = {
  type: "text"
}

// Keeps Polaris' outward prop contract — `onChange(value, id)`, a `readOnly`
// flag, `prefix`, and `multiline` as a row count — so the views that consume it
// migrate without changes.
const BasicTextField = ({
  name, label, type, handleChange, value, values, errors, placeholder,
  onChange, readOnly, prefix, suffix, multiline, helpText,
  ...otherProps
}) => {
  const onValueChange = onChange || handleChange;
  const errorMessage = errors && errors[name];

  return (
    <TextField
      fullWidth
      id={ name }
      name={ name }
      label={ label || capitalize(name) }
      type={ type }
      placeholder={ placeholder || I18n.t(`form.placeholder.${name}`) }

      onChange={ (event) => onValueChange(event.target.value, name) }
      value={ value ?? values?.[name] ?? '' }

      error={ !!errorMessage }
      helperText={ errorMessage || helpText }

      multiline={ !!multiline }
      minRows={ typeof multiline === 'number' ? multiline : undefined }

      InputProps={{
        readOnly: !!readOnly,
        startAdornment: prefix ? <InputAdornment position="start">{ prefix }</InputAdornment> : undefined,
        endAdornment: suffix ? <InputAdornment position="end">{ suffix }</InputAdornment> : undefined,
      }}
      InputLabelProps={{ shrink: true }}

      {...omit(otherProps, FORM_PROVIDER_PROPS)}
    />
  );
};


BasicTextField.propTypes = propTypes;
BasicTextField.defaultProps = defaultProps;


export default BasicTextField;
